export const keyBindings = {
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39
};



// WEBPACK FOOTER //
// ./src/common/utils.js